import React from 'react';
import CustomButton from './CustomButton';

interface ButtonConfig {
  text: string;
  action: () => void;
  disabled?: boolean;
  isActive?: boolean;
}

interface ButtonsRowProps {
  buttons: ButtonConfig[];
  className?: string;
  activeButton?: string;
  display: boolean;
}

const ButtonsRow: React.FC<ButtonsRowProps> = ({ buttons, className, activeButton, display }) => {
    const defaultClass = "flex flex-wrap justify-center gap-4 "
    const buttonsRowClassName = className ? defaultClass + className : defaultClass;
  return (
    <div className={buttonsRowClassName}>
      {buttons.map((button, index) => (
          display && index === 2 ? (<CustomButton
              key={index}
              text={button.text}
              onClick={button.action}
              disabled={button.disabled}
              isActive={activeButton === button.text}
              bgColor={'bg-[#4c6a4d]/60'}
              rounded = "rounded-full"
          />) : index !== 2 ? (<CustomButton
              key={index}
              text={button.text}
              onClick={button.action}
              disabled={button.disabled}
              isActive={activeButton === button.text}
              bgColor={'bg-[#4c6a4d]/60'}
              rounded = "rounded-full"
          />) : null
      ))}
    </div>
  );
};

export default ButtonsRow;
